export const clearErrorInput = ({ field, obj }) => {
  const objUpdated = { ...obj, [field]: '' };

  return objUpdated;
};